import {FC} from 'react';
import {Footer} from '../Footer';
import {Header} from '../Header';
import {FixedSideNavigationLayout} from './FixedSideNavigationLayout';
import {PageLayoutContainer} from './PageLayoutContainer';
import {SideNavigationLayout} from './SideNavigationLayout';
import {TopNavigationLayout} from './TopNavigationLayout';
import {PageLayoutProps} from './props';

const layouts = {
    side: SideNavigationLayout,
    fixedSide: FixedSideNavigationLayout,
    top: TopNavigationLayout
};

export const PageLayout: FC<PageLayoutProps> = ({
    children,
    ...props
}) => {
    const Layout = layouts[props.SideNavProps?.variant || 'top'];

    return (
        <PageLayoutContainer>
            <Header
                isContained={props.SideNavProps?.variant !== 'fixedSide' && props.isContained}
                {...props.HeaderProps}
            >
                {props.HeaderActionAreaComponent}
            </Header>
            <Layout
                PageTitleActionAreaComponent={props.PageTitleActionAreaComponent}
                PageTitleProps={props.PageTitleProps}
                SideNavProps={props.SideNavProps}
                isContained={props.isContained}
            >
                {children}
            </Layout>
            <Footer {...props.FooterProps}/>
        </PageLayoutContainer>
    );
};

PageLayout.displayName = 'PageLayout';
